<template>
    <div class="modal-overlay"
         @click="$emit('close-modal'), toggleBodyClass(false)"
         v-if="promotional"
    >
        <div style="margin: auto;max-width: 100%;">
            <div class="modal promotional-modal" @click.stop>
                <div class="modal__close d-flex block-center transition" @click="$emit('close-modal'), toggleBodyClass(false)">
                    <span class="icon-close transition"></span>
                </div>
                <div class="modal__inner d-flex flex-wrap">
                    <h2 class="promotional-modal__title">{{ promotional.name }}</h2>
                    <div class="promotional-modal__text" v-if="promotional.description">
                        <p>{{ promotional.description }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'PromotionalModal',
        props: {
            promotional: {
                type: Object,
                default: () => {},
            },
        },
        data() {
            return {

            };
        },
        methods: {
            toggleBodyClass(val) {
                document.body.classList.toggle('hidden', val);
            },
        },
    };
</script>
